import { CRYPTO_DECIMALS, FIAT_DECIMALS } from '../constants';
import { fiatSymbols } from '../constants/fiatSymbols';
import { supportedFiatCurrencies } from '../constants/supportedFiatCurrencies';
import { getDisplayAssetCode } from './getDisplayAssetCode';
import { formatNumber } from './numbers';

export const getAssetPrecision = (assetCode: string | null) => {
  if (!assetCode) return 0;

  const isFiat = supportedFiatCurrencies.includes(assetCode.toUpperCase());
  let precision = isFiat ? FIAT_DECIMALS : CRYPTO_DECIMALS;
  return precision;
};

export const formatAssetAmount = (
  amount: number | null,
  assetCode: string | null,
  {
    showCryptoCode = true,
    showDecimals = true,
    showSpacer = false,
    showTrimmer = false,
    shorten = false,
  }: {
    shorten?: boolean;
    showSpacer?: boolean;
    showTrimmer?: boolean;
    showDecimals?: boolean;
    showCryptoCode?: boolean;
  } = {
    showCryptoCode: true,
    showDecimals: true,
    showSpacer: false,
    showTrimmer: false,
  },
) => {
  'worklet';
  if (!assetCode) return '-';

  const isFiat = supportedFiatCurrencies.includes(assetCode);

  const symbol = isFiat
    ? fiatSymbols[assetCode?.toUpperCase()]
    : assetCode?.toUpperCase();

  if (amount == null) {
    return isFiat ? `${symbol} -` : `- ${getDisplayAssetCode(symbol)}`;
  }

  let precision = showDecimals ? (isFiat ? FIAT_DECIMALS : CRYPTO_DECIMALS) : 0;

  // RS: NB: This adjusts the precision and spacer values for fiat values when the amount is less than 0.00, to show 6 decimals
  if (amount <= 0.001 && amount >= 0.000001 && precision == 2) {
    precision = 6;
    showSpacer = false;
  }

  let value = isFiat
    ? formatNumber(amount, precision, shorten, showSpacer, showTrimmer)
    : formatNumber(amount, precision, false, true, true);

  if (!isFiat) {
    // NOTE: This preserves the thousands separators in the integers of the crypto Currency, but removes them from the decimals
    let valueWithSpaces = value.split('.')[0];
    valueWithSpaces +=
      '.' + value.split('.')[1].replace(' ', '').replace(' ', '');
    value = valueWithSpaces;
  }
  if (!isFiat && amount === 0)
    return showCryptoCode ? `${0} ${getDisplayAssetCode(symbol)}` : '0';

  return isFiat
    ? `${symbol}${value}`
    : showCryptoCode
    ? `${value} ${getDisplayAssetCode(symbol)}`
    : value;
};
